'use client';

import {
    Alignable,
    Column,
    Columns,
    Container,
    Image,
    Row,
    Rows,
    Section,
    Text,
    TextLevels,
    Title,
    TitleLevels,
} from '@bytel/trilogy-react';

type HeroProps = {
    title: string;
    subtitle: string;
    backgroundImageUrl: string;
    productImageUrl: string;
};

export function Hero({ title, subtitle, backgroundImageUrl, productImageUrl }: HeroProps) {
    return (
        <>
            <Section backgroundSrc={`'${backgroundImageUrl}'`}>
                <Container>
                    <Columns verticalAlign={Alignable.ALIGNED_CENTER} className='hero-content'>
                        <Column size={7} className='hero-text'>
                            <Rows>
                                <Row>
                                    <Title
                                        markup='h1'
                                        inverted
                                        level={TitleLevels.ONE}
                                        className='has-text-centered-mobile'
                                    >
                                        {title}
                                    </Title>
                                </Row>
                                <Row>
                                    <Text level={TextLevels.ONE} inverted className='has-text-centered-mobile subtitle'>
                                        {subtitle}
                                    </Text>
                                </Row>
                            </Rows>
                        </Column>
                        <Column>
                            <Image src={productImageUrl} alt='image des produits' className='hero-image' />
                        </Column>
                    </Columns>
                </Container>
            </Section>
        </>
    );
}
